import React, { useState, useEffect } from "react";
import { Result, Button } from "antd";
import { withRouter } from "react-router";
function Finish(props) {
  const [tips, setTips] = useState("微信子账号添加成功");
  const [status, setStatus] = useState("success");

  useEffect(() => {
    const {
      location: { search },
    } = props;

    if (search) {
      const message = search.split("?error=")[1];
      setTips(decodeURIComponent(message));
      setStatus("error");
    } else {
      setTips("微信子账号添加成功");
      setStatus("success");
    }
  }, [props.location.pathname]);

  const handleBack = () => {
    props.history.push("/WeChat/management");
  };
  return (
    <Result
      title={tips}
      status={status}
      extra={
        <Button type="primary" onClick={handleBack} key="console">
          返回
        </Button>
      }
    />
  );
}
export default withRouter(Finish);
